import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchNoticeList } from './fetch-notice-list';
import axios from '../../../utils/axios';
import { FetchNoticeDetail } from './fetch-notice-detail';

export namespace ModifyNoticeApi {
  export type ReqeustType = {
    title?: string;
    contentHtml?: string;
    noticeId: number;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, ReqeustType> = {}) => {
    const { refetch } = FetchNoticeList.useRefetchData();
    const { refetch: refetchDetail } = FetchNoticeDetail.useRefetchData();

    const mutation = useMutation(
      ({ title, contentHtml, noticeId }) => {
        return axios.put(`/notices/${noticeId}`, {
          title,
          contentHtml
        });
      },
      {
        onSuccess: (...rest) => {
          refetch();
          refetchDetail(rest[1].noticeId);
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
